import { stateStatusType, ReadingMaterialProps } from './actionType';

export interface FetchReadingMaterialState {
    isLoading: boolean;
    error: string | null;
    readingMaterial: ReadingMaterialProps | null;
    status: stateStatusType | null;
    delete: string | null;
}
export interface GenericReadingMaterial {
    isLoading: boolean;
    error: string | null;
    status: stateStatusType | null;
}
export const initalReadingMaterial: FetchReadingMaterialState = {
    isLoading: false,
    error: null,
    readingMaterial: null,
    status: null,
    delete: null,
};
export const initalGenericReadingMaterial: GenericReadingMaterial = {
    isLoading: false,
    error: null,
    status: null,
};
export interface ReadingMaterialState {
    readingMaterialState: FetchReadingMaterialState;
    genericReadingMaterialState: GenericReadingMaterial;
}

export const initialState: ReadingMaterialState = {
    readingMaterialState: initalReadingMaterial,
    genericReadingMaterialState: initalGenericReadingMaterial
};


